export class User {
	constructor(
		public id: string,
		public title: string
	) {
	}
}
